import { useEffect, useState } from "react";
import * as apiWarehouse from "api/apiWarehouses";
import ESpinner from "../../others/Spinner";
import AddTransferFormCounter from "./AddTransferFormCounter";
  
 
const AddTransferForm = ({wId, addProduct, setAddProduct, setATransfer, isLoading = false}: any) => {
    
    const [ productStocks, setProductStocks ] = useState(null);
    const productId = addProduct?.value ?? null;

    useEffect(() => {
        if (!productId) {
            setProductStocks(null);
            return;
        }

        let cancelled = false;
        setProductStocks(null);

        const fetchStockProductPrices = async () => {
            const resProductStock = await apiWarehouse.getStockByProductId(wId, productId);
            if (!cancelled) setProductStocks(resProductStock);
        };

        fetchStockProductPrices();

        return () => {
            cancelled = true;
        };
    }, [wId, productId]);
 
 
    return (<div className="px-3">
        {((productStocks  !== null) && (!isLoading))
            ? (<AddTransferFormCounter 
                    key={productId}
                    setATransfer={setATransfer}
                    setProductStocks={setProductStocks}
                    addProduct={addProduct}
                    setAddProduct={setAddProduct}
                    productStocks={productStocks} />)
            
            : (<ESpinner/>)} 
    </div>)
}

export default AddTransferForm;
